import { Component, inject, OnInit } from '@angular/core';
import { UsersService } from '@cl/core/services';
import { User } from '@cl/shared/models';
import {
    BaseEmployeeNotificationByEmail,
    BaseEmployeeNotificationByEmails,
    BaseEmployeeNotificationByUser,
    BaseEmployeeNotificationByUsers,
} from '@cl/shared/models/base/base-employee-notification.model';
import { EmployeeNotificationModalData } from '@cl/shared/models/misc/employee-notification-modal-data.model';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';

@Component({
    selector: 'cl-employee-notification-modal',
    standalone: false,
    templateUrl: './employee-notification-modal.component.html',
    styleUrl: './employee-notification-modal.component.less',
})
export class EmployeeNotificationModalComponent<
    TNotificationModel extends
        | BaseEmployeeNotificationByUser
        | BaseEmployeeNotificationByUsers
        | BaseEmployeeNotificationByEmail
        | BaseEmployeeNotificationByEmails,
> implements OnInit
{
    readonly modalData: EmployeeNotificationModalData<TNotificationModel> = inject(NZ_MODAL_DATA);

    notificationModel: TNotificationModel;
    user: User;
    users: User[];
    userEmail: string;
    userEmails: string[];
    multipleUsers: boolean = true;

    constructor(
        private modal: NzModalRef,
        private usersService: UsersService,
        private messageService: NzMessageService,
    ) {
        this.notificationModel = this.modalData.notificationModel;
        this.user = this.modalData.user;
        this.users = this.modalData.users;
        this.userEmail = this.modalData.userEmail;
        this.userEmails = this.modalData.userEmails;
    }

    ngOnInit(): void {
        if (!this.notificationModel) {
            throw new Error('NotificationModel is required');
        }

        const isUserSet: boolean = this.user != null;
        const isUsersSet: boolean = this.users && this.users.length > 0;
        const isUserEmailSet: boolean = this.userEmail && this.userEmail.trim() !== '';
        const isUserEmailsSet: boolean = this.userEmails && this.userEmails.length > 0;

        if ([isUserSet, isUsersSet, isUserEmailSet, isUserEmailsSet].filter(Boolean).length !== 1) {
            throw new Error('Exactly one of User, Users, UserEmail or UserEmails must be set!');
        }
    }

    userToString(user: User): string {
        return this.usersService.toString(user);
    }

    submitAndReturn(): void {
        if ('receiverUserIds' in this.notificationModel) {
            // BaseEmployeeNotificationByUsers
            if (!this.notificationModel.receiverUserIds || this.notificationModel.receiverUserIds.length === 0) {
                this.messageService.error('Nav izvēlēts neviens lietotājs, kuram nosūtīt paziņojumu!');
            }
        } else if ('receiverUserId' in this.notificationModel) {
            // BaseEmployeeNotificationByUser
            if (this.notificationModel.receiverUserId == null) {
                this.messageService.error('Nav izvēlēts lietotājs, kuram nosūtīt paziņojumu!');
                return;
            }
        } else if ('receiverEmail' in this.notificationModel) {
            // BaseEmployeeNotificationByEmail
            if (!this.notificationModel.receiverEmail?.trim()) {
                this.messageService.error('Paziņojuma saņēmēja epasts nav atrasts!');
                return;
            }
        } else {
            // BaseEmployeeNotificationByEmails
            if (!this.notificationModel.receiverEmails) {
                this.messageService.error('Paziņojuma saņēmēju epasti nav atrasts!');
                return;
            }
        }

        this.modal.close(this.notificationModel);
    }

    cancel(): void {
        this.modal.destroy();
    }
}
